import type { FC, ReactNode } from 'react'
import type { StoreBase } from '@/types'

import { StoreHeader } from './store-header'
import { StoreFooter } from './store-footer'

interface StoreLayoutProps {
    store: StoreBase
    children: ReactNode
}

export const StoreLayout: FC<StoreLayoutProps> = ({ store, children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#konten'
                className='sr-only z-[60] rounded-full bg-brand-choco px-5 py-3 font-semibold text-brand-cream focus:not-sr-only focus:fixed focus:left-4 focus:top-4'
            >
                Lewati ke konten utama
            </a>

            <StoreHeader settings={store.settings} categories={store.categories} />

            <main id='konten' className='flex-1'>
                {children}
            </main>

            <StoreFooter settings={store.settings} categories={store.categories} year={store.year} />
        </div>
    )
}
